import axios from "axios";
const fileBaseURL = process.env.REACT_APP_ARMBUCKET_URL


const UploadFile = async (files) => {
  try {
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append("files", file);
    });
    const uploadfile = await axios.post(
      `${fileBaseURL}/api/v1/bulk-upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return uploadfile.data;
  } catch (error) {
    console.log("Error checking:", error);
    // throw new Error('Oops, something went wrong!');
  }
};

const deleteFile = async (fileName) => {
    try {
      const deleteFile = await axios.delete(
        `${fileBaseURL}/api/v1/delete/${fileName}`,
       
      );
      return deleteFile;
    } catch (error) {
      console.log("Error checking:", error);
    }
  };

export { UploadFile, deleteFile };
